// extracted by mini-css-extract-plugin
module.exports = {"member":"styles-module--member--3VUOn","sideLabel":"styles-module--sideLabel--2CtOn","jobTitle":"styles-module--jobTitle--3BEpx"};